import React, { useEffect } from 'react';
import { socketClient } from 'Api/Socket';
import { useSocket } from './SocketProvider';

export const SocketIntegrationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { emit } = useSocket();

  useEffect(() => {
    // Connect the socket client to emit events through our SocketProvider
    socketClient.setSocketEventEmitter(emit);

    return () => {
      // Cleanup: remove the emitter reference
      socketClient.setSocketEventEmitter(undefined);
    };
  }, [emit]);

  return <>{children}</>;
};
